import type { GroupAttributes } from '../../openfeature/cacheKey'

/**
 * True when the page was rendered for a group whose device is not the device
 * hydrating it: a desktop cookie in a phone, or the other way round.
 *
 * The browser decides mobile from its user agent on every load, and the group
 * cookie was written on an earlier one. The two part when the same browser
 * changes its user agent in between, a desktop site request on a phone or a
 * DevTools device toolbar. The markup and the render flags then belong to the
 * other device, and hydrating them is a page of mismatches.
 *
 * Only the device is compared. It is the one group attribute the browser
 * reads from somewhere other than the cookie on a rendered page.
 */
export function renderedForOtherDevice(
  attributes: GroupAttributes | null,
  isMobile: boolean
): boolean {
  if (attributes?.isMobile === undefined) return false
  return attributes.isMobile !== isMobile
}
